// import * as z from 'zod';

import { type UrlParamsForApiTablaDef } from '../types/TablaDefTypes';

export function parseUrlParamsForAPiTablaDef(url: string) {
  const params = new URLSearchParams(url);

  const allParams = {};
  params.forEach((v, k) => {
    if (k === 'Syj_Id') {
      allParams[k] = Number(v);
      return;
    }

    allParams[k] = v;
  });

  /* const parsed = z
    .object({
      Cab_Id: z.string(),
      Cab_Origen: z.string(),
      Emp_Codigo: z.string(),
      Syj_Id: z.number(),
      Tablastoken: z.string(),
    })
    .parse(allParams); */

  return allParams as UrlParamsForApiTablaDef;
}
